module.exports = __webpack_public_path__ + "img/event-create-finish-chairs-animation.595715f3.gif";